export default __webpack_public_path__ + "static/wght_loss_icn-ef27f633a70a20b83fc5c6fe97f80d29.png";